import { render, staticRenderFns } from "./ClientsReport.vue?vue&type=template&id=f38b81f4&"
import script from "./ClientsReport.vue?vue&type=script&lang=js&"
export * from "./ClientsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports